import * as React from 'react';
import { Input } from '@material-ui/core';
import { InputProps } from '@material-ui/core/Input';

interface KDInputProps extends InputProps {
    onEnterKey?: (e: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) => void
}

export default class KDInput extends React.Component<KDInputProps> {

    constructor(props: KDInputProps) {
        super(props);
    }


    public render() {
        const { onEnterKey, ...props } = this.props
        return <Input {...props} onKeyDown={(e) => {
            if (e.keyCode == 13) {
                if (this.props.onEnterKey) {
                    e.preventDefault()
                    this.props.onEnterKey(e)
                }
            }
        }}>
            {this.props.children}
        </Input>
    }
}


// WEBPACK FOOTER //
// ./src/components/Input/Input.tsx